import { Timestamp, addDoc, collection, doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";
import { migrateProject, type Project } from "./types";

const COL = "shares";

export type ShareHours = 1 | 6 | 24 | 168 | 720;

export async function createShareLink(
  uid: string,
  title: string,
  data: Project,
  hours: ShareHours,
): Promise<{ id: string; url: string; expiresAt: number }> {
  const expiresAt = Timestamp.fromMillis(Date.now() + hours * 60 * 60 * 1000);
  const ref = await addDoc(collection(db, COL), {
    ownerId: uid,
    title,
    data: JSON.parse(JSON.stringify(data)),
    expiresAt,
    createdAt: Timestamp.now(),
  });
  const url = `${location.origin}${location.pathname}?v=${ref.id}`;
  return { id: ref.id, url, expiresAt: expiresAt.toMillis() };
}

export async function loadShare(id: string): Promise<{ title: string; data: Project; expiresAt: number }> {
  const snap = await getDoc(doc(db, COL, id));
  if (!snap.exists()) throw new Error("expired");
  const row = snap.data();
  const exp = row.expiresAt instanceof Timestamp ? row.expiresAt.toMillis() : Number(row.expiresAt);
  if (!exp || exp < Date.now()) throw new Error("expired");
  return {
    title: String(row.title ?? "Proyecto"),
    data: migrateProject(row.data),
    expiresAt: exp,
  };
}

export function shareIdFromUrl(): string | null {
  return new URLSearchParams(location.search).get("v");
}
